import { render, staticRenderFns } from "./ExternalStatusesConfig.vue?vue&type=template&id=624cd447&"
import script from "./ExternalStatusesConfig.vue?vue&type=script&lang=js&"
export * from "./ExternalStatusesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports